import React from 'react';
import ContentLayout from '../../../components/ContentLayout';
import props from '../../../lib/contentLayoutProps/the-kingston-difference/layoutProps';

/* eslint-disable react/prop-types */
export default () => (
  <ContentLayout {...props} locale="zh" pageKey="mission-purpose-and-the-kingston-difference">
    <h1>使命、理念及京斯敦與眾不同之處</h1>

    <h3>使命宣言</h3>
    <p>
      向學生提供具挑戰性和啟發性的雙語環境
      (英語及普通話)，培養他們全面而均衡的發展，並使他們能以個人獨特的方式成為活躍主動、具責任感的世界公民。
    </p>

    <h3>目標：我們共同致力</h3>
    <ul className="list">
      <li>彼此和諧相處；</li>
      <li>以國際情懷原則優先建立正向的人際關係；</li>
      <li>承擔學習、健康與幸福的責任；</li>
      <li>考慮個人與集體的觀點，認識每個人與事物之間的相關性；</li>
      <li>挑戰固有的觀點；</li>
      <li>建立對他人身份認同、文化、社會及歷史的理解；</li>
      <li>支持以不同的方式了解、體驗和採取行動的機會；</li>
      <li>與所有持分者建立良好、互助互利且具效能的關係；</li>
      <li>建立及維持友誼，積極學習及採取集體行動；</li>
      <li>推動自主學習，鼓勵學生運用發言權、選擇權及擁有權進行更好的學習；</li>
      <li>創建積極互動的學習環境，針對學生的長處進行多元智能學習；</li>
      <li>建立及支持全納社區。</li>
    </ul>
  </ContentLayout>
);
